<script setup>

import Table from "@/components/common/other/Table";
import {inject} from 'vue';

const shipments = inject("shipments");

function openTracking(url) {

  window.open(url);
}

</script>

<template class="cmp-customs">

  <div class="cmp-customs-wrapper">
    <Table
        :key="shipments.viewShipment.customs.length"
        height="160"
        :selectable="false"
        :row-selection="false"
        :allow-grid-menu="false"
        :allowPagination="false"
        :columns="shipments.customs.gridColumns"
        :dataSource="shipments.viewShipment.customs">
    </Table>
  </div>

</template>

<style scoped>

.cmp-customs-wrapper {
  height: 200px;

}
</style>